// src/components/NewsArticle.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { database } from "../firebase";

const NewsArticle = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      const doc = await database.collection('news').doc(id).get();
      if (doc.exists) {
        setArticle(doc.data());
      }
    };

    fetchArticle();
  }, [id]);

  if (!article) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>{article.title}</h1>
      <h3>{article.subTitle}</h3>
      <p>{article.content}</p>
      <p><strong>Meta Tags:</strong> {article.metaTags.join(', ')}</p>
      {article.metaImage && <img src={article.metaImage} alt={article.title} style={{ width: '200px' }} />}
    </div>
  );
};

export default NewsArticle;
